import classNames from 'classnames'
import { capitalCase } from 'change-case'
import { repeatsDescription } from './util'
import React from 'react'
import { ClassValue } from 'classnames/types'

interface DateScheduleBoxProps {
    dateSchedule: string
    date: Date
    className: ClassValue
    onClick: () => void
}

export const DateScheduleBox = ({
    dateSchedule,
    date,
    className,
    onClick,
}: DateScheduleBoxProps) => {
    return (
        <div className={classNames('px-1 py-1 cursor-pointer', className)} onClick={onClick}>
            <div className="font-normal">{capitalCase(dateSchedule)}</div>
            <div className="text-gray-500 text-xs">{repeatsDescription(dateSchedule, date)}</div>
        </div>
    )
}
